import React, { FC, useEffect } from 'react';
import ReusableCore from 'new/components/ReusableTransform/ReusableCore';
import AttributeTransforms from 'new/components/ReusableTransform/AttributeTransforms';
import ResizableHorizontalLayout from 'js/components/elements/ResizableHorizontalLayout';
import ReusableBuilderPreview from 'new/components/ReusableTransform/ReusableBuilderPreview';
import { ReusableTransformType } from '@nexla/@types';

export type ReusableTransformProps = {
  isCapsuleCluster?: boolean;
  isEditMode: false;
  isFetchingDataSets: false;
  isFetchingOutputSamples: false;
  isFormAwaitingValidation: false;
  isFetchingDataSetSamples: false;
  transformBeingEditedID?: number;
  transformsData: ReusableTransformType[];
  isFetchingReusableTransforms: boolean;
  runTransform(): void;
  onClickDismiss(): void;
  onEditButtonClicked: (tx: string) => void;
};

const minSizes = [200, 250, 200];
const maxSizes = [500, null, null];
const initialSizes = ['20%', '60%', '20%'];

const ReusableTransform: FC<ReusableTransformProps> = (props) => {
  useEffect(() => {
    const formBody = document.getElementById('form:overlay-body');

    if (formBody && formBody.style) formBody.style.backgroundColor = 'var(--color-greyscale-50)';

    return () => {
      if (formBody && formBody.style) formBody.style.backgroundColor = 'transparent';
    };
  }, []);

  return (
    <ResizableHorizontalLayout initialSizes={initialSizes} minSizes={minSizes} maxSizes={maxSizes}>
      <div>
        <AttributeTransforms
          isFetchingReusableTransforms={props.isFetchingReusableTransforms}
          transformsData={props.transformsData}
          transformBeingEditedID={props.transformBeingEditedID}
          onEditButtonClicked={props.onEditButtonClicked}
        />
      </div>

      <div>
        <ReusableCore {...props} />
      </div>

      <div>
        <ReusableBuilderPreview />
      </div>
    </ResizableHorizontalLayout>
  );
};

export default ReusableTransform;
